import { createSlice } from '@reduxjs/toolkit';
import { ModalStoreEntity } from '@/types/redux/interface';

const initialState: ModalStoreEntity = {
  visible: false,
};

export const modalSlice = createSlice({
  name: 'manageModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.visible = true;
    },
    closeModal: (state) => {
      state.visible = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
